<template>
	<div>
		<div :id="'builder' + id"></div>

		<edit_tabulator ref="tabulator" :extern_file="false" @data="update_data" @update="update"></edit_tabulator>
	</div>
</template>

<script>
	
	import uniqueId from "lodash.uniqueid";
	import alasql from "alasql";
    import $ from "jquery";

	import edit_tabulator from "./edit_tabulator.vue";

	import "../sass/sparkle.scss";

	const clone = require("clone")

	export default {
		name: "edit_tabulator_conditions",
		components: {
			edit_tabulator
		},
		data: function () {
			return {
				id: uniqueId(""),
				rules: "",
				rules_sql: "",
				tabulator_data: []
			};
		},
		props: {
			data: {
			},
		},
		watch: {
			tabulator_data: {
				deep: true,
				handler() {
					this.$emit("update", this.tabulator_data);
				},
			},
			async data()
			{
				try {
					this.setBuilder(Object.keys(this.data.length > 0 ? this.data[0] : {}));
					try {
						$("#builder" + this.id).queryBuilder("reset")
					}
					catch (err)
					{
					}
					await this.updatePage();
				} catch (err) {
				}
			}
		},
		methods: {
			async get_data_files()
			{
				return await this.$refs.tabulator.get_data_files()
			},
			async get_data_blob()
			{
				return await this.$refs.tabulator.get_data_blob()
			},
			async get_data()
			{
				return await this.$refs.tabulator.get_data()
			},
			update_data(data)
			{
				//console.log("update")
				this.$emit("data", data);
			},
			update(id, data)
			{
				//console.log("update")
				this.$emit("update", data);
			},
			setBuilder(columns) {

				if (columns.length == 0)
					return;

				var self = this;
				var id = this.id;

				var columns_query_builder = [];
				for (var i = 0; i < columns.length; i++) {
					columns_query_builder.push({
						id: "`" + columns[i] + "`",
						label: columns[i],
						type: "string",
					});
				}

				var config = {
					filters: columns_query_builder,
					icons: {
						add_group: "fas fa-plus-square",
						add_rule: "fas fa-plus-circle",
						remove_group: "fas fa-minus-square",
						remove_rule: "fas fa-minus-circle",
						error: "fas fa-exclamation-triangle",
					},
					operators: [
						{ type: "equal" },
						{ type: "not_equal" },
						{ type: "less" },
						{ type: "less_or_equal" },
						{ type: "greater" },
						{ type: "greater_or_equal" },
						{ type: "between" },
						{ type: "contains" },
						{ type: "not_contains" },
						{ type: "begins_with" },
						{ type: "ends_with" },
						{
							type: "is_empty",
							apply_to: [
								"string",
								"number",
								"datetime",
								"boolean",
							],
						},
						{
							type: "is_not_empty",
							apply_to: [
								"string",
								"number",
								"datetime",
								"boolean",
							],
						},
					],
				};

				$("#builder" + id).queryBuilder(config);

				$("#builder" + id).on(
					"change",
					function (e, rule, error, value) {
						try {
							self.rules_sql = $("#builder" + id).queryBuilder(
								"getSQL",
								false
							).sql;
							self.rules_sql = " " + self.rules_sql;
							self.rules_sql = self.rules_sql.replace(
								/`([^`]*)` = ''/gi,
								"(`$1` = '' or `$1` is NULL)"
							);
							self.rules_sql = self.rules_sql.replace(
								/`([^`]*)` != ''/gi,
								"(`$1` != '' and `$1` is not NULL)"
							);
							self.rules = $("#builder" + id).queryBuilder(
								"getRules"
							);
							self.updatePage();
						} catch (err) {
							self.rules_sql = "";
						}
					}
				);

				$("#builder" + id).on(
					"afterDeleteRule.queryBuilder",
					function (e, rule, error, value) {
						try {
							//self.rules = $('#builder').queryBuilder('getRules');
							self.rules_sql = $("#builder" + id).queryBuilder(
								"getSQL",
								false
							).sql;
							self.rules_sql = " " + self.rules_sql;
							self.updatePage();
						} catch (err) {
							self.rules_sql = "";
							self.updatePage();
						}
					}
				);
			},
			async updatePage(event = null) {
				this.request = "";
				if (this.rules_sql) 
					this.request = " WHERE " + this.rules_sql;

				//console.log(this.request)

				if (this.request)
					this.tabulator_data = alasql(
						"SELECT * FROM ? " + this.request,
						[this.data]
					);
				else 
					this.tabulator_data = this.data;

				this.$refs.tabulator.load(this.tabulator_data);
			},
			reset() {
				$("#builder" + this.id).queryBuilder("reset");
				this.rules_sql = "";
				this.updatePage();
			},
			save()
			{

			},
			load()
			{

			}
		},
		mounted: async function () {
			this.setBuilder(this.data.length > 0 ? Object.keys(this.data[0]) : []);
			this.updatePage();
		},
	};
</script>

<style>
</style>
